import { siteUrl } from './seo';

const OPT_OUT_KEY = 'vl-analytics-optout';
const VISIT_KEY = 'vl-visit';
const siteHost = new URL(siteUrl).hostname.replace(/^www\./, '');
let lastPage = null;
let memoryVisit = null;

const store = (storage, action, key, value) => {
  try {
    const target = window[storage];
    if (action === 'get') return target.getItem(key);
    if (action === 'set') target.setItem(key, value);
    else target.removeItem(key);
  } catch (error) {}
  return null;
};

const randomId = () => {
  try { if (window.crypto?.randomUUID) return window.crypto.randomUUID(); } catch (error) {}
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
};

function optedOut() {
  const params = new URLSearchParams(window.location.search);
  if (params.has('notrack')) store('localStorage', 'set', OPT_OUT_KEY, '1');
  else if (params.has('track')) store('localStorage', 'remove', OPT_OUT_KEY);
  return store('localStorage', 'get', OPT_OUT_KEY) === '1';
}

// Trailing slash on purpose: vercel.json has trailingSlash: true, so /api/track would 308 to /api/track/.
const ENDPOINT = '/api/track/';

function send(body) {
  if (navigator.sendBeacon?.(ENDPOINT, body)) return;
  if (typeof fetch === 'function') fetch(ENDPOINT, { method: 'POST', body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(() => {});
}

// `options.hostname` exists only so tests can simulate the production host.
export function trackPageView({ route, seo }, options = {}) {
  try {
    const host = (options.hostname ?? window.location.hostname).replace(/^www\./, '');
    if (optedOut() || process.env.REACT_APP_ANALYTICS_ENABLED !== 'true' || host !== siteHost || navigator.webdriver === true) return;
    const page = new URL(seo.canonical).pathname;
    if (page === lastPage) return;
    lastPage = page;
    const existing = store('sessionStorage', 'get', VISIT_KEY) || memoryVisit;
    const visit = existing || randomId();
    memoryVisit = visit;
    if (!existing) store('sessionStorage', 'set', VISIT_KEY, visit);
    const landing = !existing;
    let referrer = '';
    if (landing && document.referrer) {
      try {
        const referrerHost = new URL(document.referrer).hostname.replace(/^www\./, '');
        if (referrerHost && referrerHost !== host) referrer = referrerHost;
      } catch (error) {}
    }
    send(JSON.stringify({ page, landing, referrer, visit, ...(page === '/404/' ? { missing: window.location.pathname.slice(0, 200) } : {}) }));
  } catch (error) {}
}

export function resetForTests() {
  lastPage = null;
  memoryVisit = null;
}
